import { render, staticRenderFns } from "./ci_icon.vue?vue&type=template&id=4732472a&"
import script from "./ci_icon.vue?vue&type=script&lang=js&"
export * from "./ci_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ci_icon.vue"
export default component.exports